import { isEqual } from 'lodash-es';
import type { FilterParam } from '@/components/filter/filter-types';
import config from '@/lib/filter-params/config';
import { serializeFilterParams } from '@/lib/filter-params';
import type { ListQuery, ListQueryVariables } from '@/lib/goliath/goliath.types';

export const getUpperCategoryPath = (path: string) =>
  path.split(config.separators.path).slice(0, -1).join(config.separators.path);

export const getRedirectPath = (ViewFilter: FilterParam | undefined) => {
  if (!ViewFilter) return '';
  if (!ViewFilter.productCategoryPaths || ViewFilter.productCategoryPaths.length === 0) {
    return '';
  }
  const productCategoryPath = ViewFilter.productCategoryPaths[0];
  return ViewFilter.brandSlugs && ViewFilter.brandSlugs.length > 0
    ? productCategoryPath
    : getUpperCategoryPath(productCategoryPath);
};

/**
 * When we have such an url:
 * "/zubehoer/halterungen+lader-kabel-adapter+schutzfolien-schutzglaeser"
 * Goliath searches for Products in these 3 categories.
 * Goliath returns in the aggregations ony categories with products inside.
 * To prevent a deadlock für the next filter, we remove all categories without any product.
 */

export const checkCategoryFilters = (
  query: ListQueryVariables,
  offers: ListQuery['offers'] | undefined
) => {
  if (!offers) return undefined;
  const { aggregations, variantsCount } = offers;
  if (!variantsCount || variantsCount === 0) return undefined;
  if (!query.filter?.productCategoryPaths || query.filter.productCategoryPaths.length === 0) {
    return undefined;
  }
  // get all possible categories goliath provided
  const responseProductCategoryPaths =
    aggregations?.productCategories?.flatMap((category) => [
      category?.productCategory?.path,
      ...(category?.children || []).map((child) => child?.productCategory?.path),
    ]) || [];

  // Only keep paths that exist in responseProductCategoryPaths
  const newProductCategoryPaths = query.filter.productCategoryPaths.filter((path) =>
    responseProductCategoryPaths.includes(path)
  );
  // when there is no category, we do not want to redirect here.
  if (newProductCategoryPaths.length === 0) return undefined;
  if (!isEqual(query.filter.productCategoryPaths, newProductCategoryPaths)) {
    return serializeFilterParams({
      ...query,
      filter: {
        ...query.filter,
        productCategoryPaths: newProductCategoryPaths,
      },
    } as ListQueryVariables);
  }
  return undefined;
};

export default getRedirectPath;
